var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('Logo')],1),_c('main',{staticClass:"py-22 px-4 lg:px-10 lg:py-22 bg-litergray min-h-screen relative"},[_c('TopSection',{attrs:{"title-and-name":_vm.name}}),_c('MidPaySlip',{staticClass:"mt-8"}),_c('AuthorizedSection')],1),(_vm.$store.getters['admin/adHocOtpRefresh'])?_c('OtpAuthModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }